import { globalConfig } from '../config/client';

export function hasAiBuilderReferral(): boolean {
  const queryParams = new URLSearchParams(window.location.search);
  const utmCampaign = queryParams.get('utm_campaign');

  if (!utmCampaign || !globalConfig.config.aiStoreBuilderReferral) {
    return false;
  }

  return utmCampaign === globalConfig.config.aiStoreBuilderReferral;
}

function sanitizeReferralInfo(value: string | null): string | null {
  return value?.split(/[?&][^?&=]+=/)[0] ?? null;
}

export function getReferralInfo(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const queryParams = new URLSearchParams(window.location.search);

  const utmCampaign = queryParams.get('utm_campaign');
  if (utmCampaign) {
    return sanitizeReferralInfo(utmCampaign);
  }

  return queryParams.get('referralInfo');
}
